import React, { useState, useEffect } from 'react';

export const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // Professional African development images
  const backgroundImages = [
    'https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=1920&h=1080&fit=crop&crop=center', // African business woman
    'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1920&h=1080&fit=crop&crop=center'  // African team collaboration
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % backgroundImages.length);
    }, 5000);
    
    return () => clearInterval(timer);
  }, []);

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden">
      
      {/* Background Image Slider - Full Screen from top */}
      <div className="absolute inset-0 z-0">
        {backgroundImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
            style={{
              backgroundImage: `url(${image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat'
            }}
          >
            {/* Overlay for logo/text readability */}
            <div className="absolute inset-0 bg-black/40"></div>
          </div>
        ))}
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-20">
        {backgroundImages.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentSlide 
                ? 'bg-white w-8' 
                : 'bg-white/50 hover:bg-white/80'
            }`}
          />
        ))}
      </div>

      {/* Company Logo and Name - Centered */}
      <div className="relative h-full flex items-center justify-center z-10">
        <div className="text-center animate-fadeInUp">
          
          {/* Large Logo */}
          <div className="mb-8">
            <img 
              src="https://customer-assets.emergentagent.com/job_mande-experts/artifacts/z0cnnuyb_Logo-%20Evidentia.jpeg" 
              alt="Evidentia Logo" 
              className="h-32 w-auto mx-auto drop-shadow-2xl"
              onError={(e) => {
                const parent = e.target.parentElement;
                parent.innerHTML = '<div class="text-6xl font-bold text-white drop-shadow-2xl">EVIDENTIA AFRICA</div>';
              }}
            />
          </div>

          {/* Large Company Name */}
          <h1 className="text-6xl lg:text-8xl font-black text-white drop-shadow-2xl mb-4 tracking-wider">
            EVIDENTIA AFRICA
          </h1>
          
          {/* Tagline */}
          <p className="text-xl lg:text-2xl text-white/90 font-semibold drop-shadow-lg tracking-wide">
            Monitoring & Evaluation Excellence
          </p>
        </div>
      </div>
    </section>
  );
};